




import { Component, Vue } from 'vue-property-decorator';
import Footbowl from '@/components/game/footbowl/Footbowl.vue';

const footbowlAssets = require.context('@/assets/footbowl/', true, /\.(webm|mp4|png|jpg)$/);

@Component({
  components: {
    Footbowl,
  },
})
export default class FootbowlGame extends Vue {
  public created() {
    // Add all footbowl assets to the head to be preloaded
    footbowlAssets.keys().map((key) => {
      if (key.endsWith('.png') || key.endsWith('.jpg')) {
        const asset = footbowlAssets(key);
        const img = new Image();
        img.src = asset;
        img.onload = () => {
          // tslint:disable-next-line:no-console
          console.info(`Preloaded ${asset}`);
        };
      } else {
        const asset = footbowlAssets(key);
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = asset;
        document.head.appendChild(link);
      }
    });
  }
}
